<template>
  <div class="comment-page">

    <!-- 页面头部 -->
    <div class="page-header">
      <div>
        <div class="page-title">评论管理</div>
        <div class="page-desc">
          查看和管理用户评论，及时回复用户反馈
        </div>
      </div>
    </div>

    <!-- 搜索区域 -->
    <el-card class="search-card" shadow="never">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item>
          <el-input v-model="searchForm.content" placeholder="请输入评论内容" clearable prefix-icon="el-icon-search"
            style="width: 280px" @keyup.enter.native="handleSearch" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">
            查询
          </el-button>

          <el-button icon="el-icon-refresh" @click="handleReset">
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 评论列表 -->
    <el-card class="table-card" shadow="never">
      <div class="table-header">
        <div class="table-title">
          评论列表
        </div>

        <div class="table-total">
          共 {{ total }} 条评论
        </div>
      </div>

      <el-table :data="tableData" v-loading="loading" border class="comment-table">

        <!-- 用户 -->
        <el-table-column label="用户" width="220">
          <template slot-scope="{ row }">
            <div class="user-info">

              <el-image class="user-avatar" :src="row.user && row.user.pic" fit="cover">
                <div slot="error" class="image-error">
                  <i class="el-icon-user"></i>
                </div>
              </el-image>

              <div class="user-detail">
                <div class="user-name">
                  {{
                    row.user && row.user.nickname
                      ? row.user.nickname
                      : '-'
                  }}
                </div>

                <div class="user-id">
                  用户编号：
                  {{
                    row.user && row.user.code
                      ? row.user.code
                      : '-'
                  }}
                </div>
              </div>

            </div>
          </template>
        </el-table-column>

        <!-- 评论内容 -->
        <el-table-column label="评论内容" min-width="460">
          <template slot-scope="{ row }">
            <div class="comment-content">

              <!-- 用户评论文字 -->
              <div class="comment-text">
                {{ row.content || '-' }}
              </div>

              <!-- 用户评论图片 -->
              <div v-if="getImageList(row.pic).length" class="comment-images">
                <el-image v-for="(img, index) in getImageList(row.pic)" :key="index" class="comment-image" :src="img"
                  :preview-src-list="getImageList(row.pic)" fit="cover" />
              </div>

              <!-- 所属内容 -->
              <div v-if="row.sourceTitle" class="comment-source">
                所属内容：
                <span>{{ row.sourceTitle }}</span>
              </div>

              <!-- 回复记录 -->
              <div v-if="
                row.comment_reply_list &&
                row.comment_reply_list.length
              " class="reply-preview">

                <div v-for="(item, index) in row.comment_reply_list" :key="index" class="reply-item">

                  <!-- 回复文字 -->
                  <div class="reply-text">

                    <span v-if="item.type == 1" class="reply-label">
                      管理员回复：
                    </span>

                    <span v-else class="reply-label user-reply-label">
                      用户回复：
                    </span>

                    <span>
                      {{ item.content || '-' }}
                    </span>

                  </div>

                  <!-- 回复图片 -->
                  <div v-if="getImageList(item.pic).length" class="comment-images reply-images">
                    <el-image v-for="(img, imgIndex) in getImageList(item.pic)" :key="imgIndex" class="comment-image"
                      :src="img" :preview-src-list="getImageList(item.pic)" fit="cover" />
                  </div>



                  <div>
                    <el-button type="text" size="mini" style="color: red;margin-top: 10px;"
                      @click="deleteReplyMessage(item)">删除回复消息</el-button>
                  </div>

                </div>

              </div>

            </div>
          </template>
        </el-table-column>

        <!-- 评论时间 -->
        <el-table-column label="评论时间" width="180" prop="add_time" />

        <!-- 操作 -->
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="{ row }">

            <el-button type="text" size="small" @click="handleReply(row)">
              回复
            </el-button>


            <el-button type="text" size="small" @click="orderCommentDel(row)" style="color: red;">
              删除评价
            </el-button>
          </template>
        </el-table-column>

      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
          :page-size="searchForm.limit" :current-page="searchForm.page" :page-sizes="[10, 20, 30, 50]"
          @current-change="handlePageChange" @size-change="handleSizeChange" />
      </div>

    </el-card>

    <!-- 回复弹窗 -->
    <el-dialog title="回复评论" :visible.sync="replyDialogVisible" width="620px" custom-class="reply-dialog"
      @close="resetReply">

      <div v-if="currentComment" class="reply-dialog-content">

        <!-- 用户信息 -->
        <div class="dialog-user">

          <el-image class="dialog-avatar" :src="currentComment.user &&
            currentComment.user.pic
            " fit="cover">
            <div slot="error" class="image-error">
              <i class="el-icon-user"></i>
            </div>
          </el-image>

          <div class="dialog-user-info">

            <div class="dialog-user-name">
              {{
                currentComment.user &&
                  currentComment.user.nickname
                  ? currentComment.user.nickname
                  : '-'
              }}
            </div>

            <div class="dialog-user-code">
              用户编号：
              {{
                currentComment.user &&
                  currentComment.user.code
                  ? currentComment.user.code
                  : '-'
              }}
            </div>

          </div>

        </div>

        <!-- 原评论 -->
        <div class="original-comment">

          <div class="section-label">
            用户评论
          </div>

          <div class="original-content">

            <div class="original-text">
              {{ currentComment.content || '-' }}
            </div>

            <!-- 原评论图片 -->
            <div v-if="
              getImageList(currentComment.pic).length
            " class="comment-images">
              <el-image v-for="
(img, index) in
  getImageList(currentComment.pic)
                " :key="index" class="comment-image" :src="img" :preview-src-list="getImageList(currentComment.pic)
                  " fit="cover" />
            </div>

          </div>

        </div>

        <!-- 回复表单 -->
        <el-form ref="replyForm" :model="replyForm" :rules="replyRules" label-position="top">

          <!-- 回复文字 -->
          <el-form-item label="回复内容" prop="content">
            <el-input v-model="replyForm.content" type="textarea" :rows="5" maxlength="500" show-word-limit
              placeholder="请输入回复内容" />
          </el-form-item>

          <!-- 回复图片 -->
          <el-form-item label="回复图片" prop="pic" class="upload-form-item">
            <uploadFile :limit="20" :img-list-string="replyForm.pic" @fileChange="
              uploadChange($event, 'content_pic')
              " />

            <div class="upload-tip">
              支持上传多张图片，最多20张
            </div>
          </el-form-item>

        </el-form>

      </div>

      <span slot="footer">

        <el-button @click="replyDialogVisible = false">
          取消
        </el-button>

        <el-button type="primary" :loading="replyLoading" @click="submitReply">
          提交回复
        </el-button>

      </span>

    </el-dialog>

  </div>
</template>

<script>
import {
  orderCommentCommentList,
  orderCommentReplyAdd,
  orderCommentCommentDel,
  orderCommentReplyDel
} from '@/api/xgcApi'

import uploadFile from '@/components/uploadFileSpecification'

export default {
  name: 'CommentManage',

  components: {
    uploadFile
  },

  data() {
    return {
      // 列表加载
      loading: false,

      // 回复提交加载
      replyLoading: false,

      // 总条数
      total: 0,

      // 查询参数
      searchForm: {
        page: 1,
        limit: 10,
        content: ''
      },

      // 表格数据
      tableData: [],

      // 回复弹窗
      replyDialogVisible: false,

      // 当前评论
      currentComment: null,

      // 回复表单
      replyForm: {
        content: '',
        pic: ''
      },

      // 回复校验
      replyRules: {
        content: [
          {
            required: true,
            message: '请输入回复内容',
            trigger: 'blur'
          }
        ]
      }
    }
  },

  created() {
    this.getCommentList()
  },

  methods: {

    /**
     * 获取评论列表
     */
    getCommentList() {
      this.loading = true

      orderCommentCommentList({
        kor_type: 0,
        page: this.searchForm.page,
        limit: this.searchForm.limit,
        content: this.searchForm.content
      })
        .then(res => {
          const data = res.data || {}

          this.tableData =
            data.records ||
            data.rows ||
            data.list ||
            res.rows ||
            []

          this.total =
            data.total ||
            res.total ||
            0
        })
        .catch(() => {
          this.tableData = []
          this.total = 0
        })
        .finally(() => {
          this.loading = false
        })
    },

    /**
     * 处理图片地址
     *
     * 兼容：
     * 1. 单张URL
     * 2. 逗号分隔URL
     * 3. JSON数组字符串
     * 4. 数组
     */
    getImageList(pic) {
      if (!pic) {
        return []
      }

      // 数组
      if (Array.isArray(pic)) {
        return pic.filter(item => item)
      }

      // 字符串
      if (typeof pic === 'string') {
        pic = pic.trim()

        if (!pic) {
          return []
        }

        // JSON数组字符串
        try {
          const result = JSON.parse(pic)

          if (Array.isArray(result)) {
            return result.filter(item => item)
          }
        } catch (e) {
          // 普通字符串，继续处理
        }

        // 逗号分隔字符串
        return pic
          .split(',')
          .map(item => item.trim())
          .filter(item => item)
      }

      return []
    },

    /**
     * 上传图片变化
     *
     * uploadFile组件返回数组
     * 这里转换为接口需要的逗号分隔字符串
     */
    uploadChange(value, field) {
      if (field === 'content_pic') {
        if (Array.isArray(value)) {
          this.replyForm.pic = value
            .filter(item => item)
            .join(',')
        } else {
          this.replyForm.pic = value || ''
        }
      }
    },

    /**
     * 查询
     */
    handleSearch() {
      this.searchForm.page = 1
      this.getCommentList()
    },

    /**
     * 重置
     */
    handleReset() {
      this.searchForm.content = ''
      this.searchForm.page = 1
      this.getCommentList()
    },

    /**
     * 页码改变
     */
    handlePageChange(page) {
      this.searchForm.page = page
      this.getCommentList()
    },

    /**
     * 每页条数改变
     */
    handleSizeChange(size) {
      this.searchForm.limit = size
      this.searchForm.page = 1
      this.getCommentList()
    },

    /**
     * 打开回复弹窗
     */
    handleReply(row) {
      this.currentComment = row

      // 新增回复，每次打开清空
      this.replyForm.content = ''
      this.replyForm.pic = ''

      this.replyDialogVisible = true
    },
    /**
         * 删除评价
         */
    orderCommentDel(row) {
      this.$confirm('此操作将永久删除该评论, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        orderCommentCommentDel({ comment_id: row.id, }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          // 刷新列表
          this.getCommentList()
        })

      }).catch(() => {
      });
    },
    // 删除回复消息
    deleteReplyMessage(row) {
      this.$confirm('确定删除此条回复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        orderCommentReplyDel({ comment_reply_id: row.id, }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          // 刷新列表
          this.getCommentList()
        })

      }).catch(() => {
      });
    },


    /**
     * 重置回复表单
     */
    resetReply() {
      this.currentComment = null
      this.replyForm.content = ''
      this.replyForm.pic = ''
      if (this.$refs.replyForm) {
        this.$refs.replyForm.resetFields()
      }
    },

    /**
     * 提交回复
     */
    submitReply() {
      this.$refs.replyForm.validate(valid => {
        if (!valid) {
          return
        }
        if (
          !this.currentComment ||
          !this.currentComment.id
        ) {
          this.$message.error('评论信息不存在')
          return
        }
        this.replyLoading = true
        orderCommentReplyAdd({
          comment_id: this.currentComment.id,
          content: this.replyForm.content,
          pic: this.replyForm.pic || ''
        })
          .then(() => {
            this.$message.success('回复成功')
            this.replyDialogVisible = false
            // 刷新列表
            this.getCommentList()
          })
          .catch(() => {
            this.$message.error('回复失败')
          })
          .finally(() => {
            this.replyLoading = false
          })
      })
    }

  }
}
</script>

<style scoped>
.comment-page {
  min-height: 100%;
  padding: 24px;
  background: #f5f7fa;
}

/* 页面头部 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  font-size: 22px;
  font-weight: 600;
  color: #303133;
  line-height: 32px;
}

.page-desc {
  margin-top: 6px;
  font-size: 13px;
  color: #909399;
}

/* 搜索卡片 */
.search-card {
  margin-bottom: 16px;
  border-radius: 6px;
}

.search-form {
  margin-bottom: -18px;
}

/* 表格卡片 */
.table-card {
  border-radius: 6px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}

.table-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.table-total {
  font-size: 13px;
  color: #909399;
}

/* 用户信息 */
.user-info {
  display: flex;
  align-items: center;
}

.user-avatar {
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
}

.user-avatar ::v-deep img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.user-detail {
  margin-left: 10px;
  overflow: hidden;
}

.user-name {
  font-size: 14px;
  color: #303133;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-id {
  font-size: 12px;
  color: #a8abb2;
}

/* 评论内容 */
.comment-content {
  padding: 4px 0;
}

.comment-text {
  color: #303133;
  line-height: 22px;
  font-size: 14px;
  word-break: break-all;
}

.comment-source {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}

.comment-source span {
  color: #409eff;
}

/* 图片 */
.comment-images {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.comment-image {
  width: 64px;
  height: 64px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #ebeef5;
  cursor: pointer;
  background: #f5f7fa;
}

.comment-image ::v-deep img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 回复区域 */
.reply-preview {
  margin-top: 12px;
  padding: 10px 12px;
  background: #f5f7fa;
  border-radius: 4px;
  color: #606266;
  font-size: 12px;
  line-height: 22px;
}

.reply-item {
  padding: 4px 0;
  word-break: break-all;
}

.reply-item+.reply-item {
  border-top: 1px solid #ebeef5;
  margin-top: 6px;
  padding-top: 8px;
}

.reply-text {
  line-height: 22px;
}

.reply-label {
  color: #67c23a;
  font-weight: 500;
  margin-right: 4px;
}

.user-reply-label {
  color: #409eff;
}

.reply-images {
  margin-top: 8px;
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

/* 弹窗 */
.reply-dialog-content {
  padding: 0 4px;
}

.dialog-user {
  display: flex;
  align-items: center;
  margin-bottom: 22px;
}

.dialog-avatar {
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
}

.dialog-avatar ::v-deep img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.dialog-user-info {
  margin-left: 12px;
}

.dialog-user-name {
  font-size: 15px;
  color: #303133;
  font-weight: 500;
  margin-bottom: 6px;
}

.dialog-user-code {
  color: #909399;
  font-size: 12px;
}

/* 原评论 */
.original-comment {
  margin-bottom: 22px;
}

.section-label {
  margin-bottom: 10px;
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}

.original-content {
  padding: 14px 16px;
  background: #f5f7fa;
  border-radius: 5px;
  color: #606266;
  line-height: 24px;
  font-size: 14px;
}

.original-text {
  word-break: break-all;
}

/* 上传 */
.upload-form-item {
  margin-top: 8px;
}

.upload-tip {
  margin-top: 8px;
  color: #909399;
  font-size: 12px;
}

.image-error {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  background: #f5f7fa;
  font-size: 20px;
}
</style>